import { addImposterToUrl } from 'Utils';
import { ISelfReferralPingItem } from 'Interfaces/SelfServiceReferrals';
import { api } from '../axios';

const dataBaseURL = '/SelfServiceReferrals';

export const POLL_INTERVAL_MS = 10_000;
export const CLIENT_TIMEOUT_MS = 10 * 60 * 1000;

export const pingSelfReferralFiles = async (
  tickers: readonly string[],
): Promise<ISelfReferralPingItem[]> => {
  if (tickers.length === 0) return [];

  const params = new URLSearchParams();
  tickers.forEach((ticker) => params.append('tickers', ticker));

  const result = await api.get<ISelfReferralPingItem[]>(
    addImposterToUrl(
      `${dataBaseURL}/pingFileExisting?${params.toString()}`,
      false,
    ),
  );
  return result.data ?? [];
};
